import type { ReactNode } from "react";
import { Heading } from "@/components/catalyst/Heading";
import {
	Pagination,
	PaginationNext,
	PaginationPrevious,
} from "@/components/catalyst/Pagination";
import {
	Table,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/catalyst/Table";
import { Fab } from "@/components/Fab";

interface ReferralLinksLayoutProps {
	children: ReactNode;
	onCreateClick: () => void;
	onNext: () => void;
	onPrevious: () => void;
	hasPrevious: boolean;
	hasNext: boolean;
	isEmpty?: boolean;
	emptyState?: ReactNode;
}

export function ReferralLinksLayout({
	children,
	onCreateClick,
	onNext,
	onPrevious,
	hasPrevious,
	hasNext,
	isEmpty,
	emptyState,
}: ReferralLinksLayoutProps) {
	return (
		<div>
			<div className="flex items-center justify-between">
				<Heading level={2}>Referral Links</Heading>
			</div>

			{isEmpty && emptyState ? (
				<div className="mt-8">{emptyState}</div>
			) : (
				<>
					<Table className="mt-8">
						<TableHead>
							<TableRow>
								<TableHeader>Partner</TableHeader>
								<TableHeader>Code</TableHeader>
								<TableHeader>Plan</TableHeader>
								<TableHeader>Redemptions</TableHeader>
								<TableHeader>Status</TableHeader>
								<TableHeader>Approval</TableHeader>
								<TableHeader>Created</TableHeader>
								<TableHeader>
									<span className="sr-only">Actions</span>
								</TableHeader>
							</TableRow>
						</TableHead>
						{children}
					</Table>

					<Pagination className="mt-4">
						<PaginationPrevious
							onClick={hasPrevious ? onPrevious : undefined}
							className={
								!hasPrevious
									? "pointer-events-none opacity-50"
									: "cursor-pointer!"
							}
							href={hasPrevious ? undefined : "#"}
						/>
						<PaginationNext
							onClick={hasNext ? onNext : undefined}
							className={
								!hasNext ? "pointer-events-none opacity-50" : "cursor-pointer!"
							}
							href={hasNext ? undefined : "#"}
						/>
					</Pagination>
				</>
			)}
			<Fab label="New Referral Link" onClick={onCreateClick} />
		</div>
	);
}
